module.exports = __webpack_public_path__ + "img/pr-3.753f2cd2.png";